<template>
    <div class="card mb-3">
        <div class="card-body" :class="{'b-air': section.is_chapter}" v-if="!isEdit">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="card-title d-flex jutify-content-start" :class="{
                    'text-muted': !section.section_name,
                    'font-weight-bold': section.is_chapter
                }">
                    <div class="mr-2" v-if="!section.is_chapter">
                        {{ section.order }}.
                    </div>
                    <h5 class="mr-2">
                        {{section.section_name || "(無題)"}}
                    </h5>
                    <div>
                        <span class="badge badge-danger" v-if="section.is_finish">
                            最終話
                        </span>
                    </div>
                </div>
                <div class="d-flex justify-content-end ml-auto mb-2" v-if="!section.is_chapter">
                    <div class="small mr-1">
                        {{$filters.numberFormat(section.characters)}} 文字 |
                    </div>
                    <div class="small">
                        <span v-if="section.publish_at">{{$filters.dateFormat(section.publish_at)}}</span>
                        <span v-else class="text-danger">未公開</span>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-wrap flex-md-nowrap" :class="{
                'justify-content-between': !section.is_chapter,
                'justify-content-end': section.is_chapter,
            }">
                <div v-if="!section.is_chapter" class="card-text common small">
                    <p v-if="section.plot">{{$filters.truncate(section.plot, 140)}}</p>
                    <a href="#" v-else class="text-muted" @click.prevent="edit()">プロットを追加...</a>
                </div>
                <div class="d-flex justify-content-end ml-auto min-200" :class="{'chapter-menu': section.is_chapter}">
                    <button class="btn btn-link btn-sm text-warning" @click="$emit('debug', section)" v-if="isDebug && !section.is_chapter">
                        <i class="fas fa-bug"></i> 執筆記録
                    </button>
                    <button class="btn btn-link btn-sm" @click="edit()" :disabled="isSorted || hasNew">
                        <i class="fas fa-edit"></i> 編集
                    </button>
                    <button class="btn btn-link btn-sm" @click="$emit('moveSection', section)" :disabled="hasNew">
                        <i class="fas fa-sort"></i> 移動
                    </button>
                    <button class="btn btn-link btn-sm text-danger" :disabled="section.characters > 0 || isSorted || hasNew" @click="$emit('remove', section)" >
                        <i class="fas fa-times"></i> 削除
                    </button>
                </div>
            </div>
        </div>
        <div class="card-body" :class="{'bg-chapter': editor.is_chapter}" v-else>
            <div class="d-flex justify-content-between flex-wrap">
                <div class="card-title d-flex justify-content-between flex-fill mr-3">
                    <input type="text"
                        class="form-control section_name mr-2 transparent"
                        ref="section_name"
                        v-model="editor.section_name"
                        :placeholder="placeholder"
                        @keydown="input($event)">
                    <label class="btn btn-outline-danger btn-sm text-nowrap"
                        :class="{active: editor.is_finish}">
                        <input type="checkbox" v-model="editor.is_finish" :value="1" class="d-none">
                        <i class="fas fa-check-circle" v-if="editor.is_finish"></i>
                        <i class="far fa-circle" v-else></i>
                        最終話
                    </label>
                </div>
                <div class="d-flex justify-content-end ml-auto mb-2" v-if="!section.is_chapter">
                    <div class="small mr-1">
                        {{$filters.numberFormat(section.characters)}} 文字 |
                    </div>
                    <div class="small">
                        <span v-if="section.publish_at">{{$filters.dateFormat(section.publish_at)}}</span>
                        <span v-else class="text-danger">未公開</span>
                    </div>
                </div>
            </div>
            <div class="d-flex flex-wrap flex-md-nowrap" :class="{
                'justify-content-between': !section.is_chapter,
                'justify-content-end': section.is_chapter,
            }">
                <div v-if="!editor.is_chapter" class="card-text common flex-fill">
                    <div class="text-pane">
                        <textarea v-model="editor.plot"
                            @keydown="input($event)"
                            class="plot"
                            ref="plot"
                            placeholder="プロットを140字以内で記述..."></textarea>
                        <div class="dummy">{{editor.plot + '\u200b'}}</div>
                    </div>
                    <div class="small">
                        {{plotLength}} / 140文字
                    </div>
                </div>
                <div class="d-flex justify-content-end ml-auto min-200">
                    <button class="btn btn-link btn-sm" @click="save()">
                        <i class="fas fa-check"></i> 保存
                    </button>
                    <button class="btn btn-link btn-sm text-danger" @click="cancel()">
                        <i class="fas fa-times"></i> キャンセル
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.min-200 {
    min-width: 200px;
}
.chapter-menu {
    margin-top: -2rem;
}
.section_name {
    font-size: 1.125rem;
    background: transparent !important;
    border-bottom: 1px solid #aaa;
    border-radius: 0;
    padding: 0 0 .2rem;
    height: 1.325rem;
}
.card-text {
    letter-spacing: 1px;
    font-size: 0.75rem;
}
.text-pane {
    position: relative;
    border: 0;
    .dummy {
        overflow: hidden;
        box-sizing: border-box;
        padding: 0;
        min-height: 32px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        line-height: 1.3rem;
        font-size: 0.75rem;
        visibility: hidden;
        border: 0;
    }
    .plot {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        letter-spacing: 1px;
        line-height: 1.3rem;
        font-size: 0.75rem;
        padding: 0;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        background: transparent;
        &:focus {
            outline: none;
        }
    }
}
.form-control:focus, .btn:focus {
    // border: 0;
    box-shadow: none;
}
</style>

<script>
export default {
    props: {
        section: {
            default: {}
        },
        isDebug: {
            default: false,
        },
        isSorted: {
            default: false,
        },
        hasNew: {
            default: false,
        },
    },
    data() {
        return {
            editor: {},
            isEdit: false,
        }
    },
    methods: {
        edit() {
            this.editor = _.cloneDeep(this.section);
            this.isEdit = true;
            setTimeout(() => {
                if (this.editor.section_name) {
                    this.$refs.plot.focus();
                } else {
                    this.$refs.section_name.focus();
                }
            });
        },
        save() {
            if (!this.editor.section_name && !this.editor.plot) {
                if (this.editor.is_chapter) {
                    alert.warn("章タイトルを入力してください。");
                } else {
                    alert.warn("タイトルかプロットを入力してください。");
                }
                return;
            }
            axios.post("/mypage/book/plot/save", this.editor).then(res => {
                alert.msg(res.data);
                this.cancel();
            }).catch(err => { alert.err(err.response) });
        },
        cancel() {
            this.isEdit = false;
            this.editor = {};
            this.$emit("reload", this.section.id);
        },
        input(ev) {
            if (ev.code === "Enter") {
                ev.preventDefault();
                if (ev.metaKey || ev.ctrlKey) {
                    this.save();
                }
            }
        }
    },
    computed: {
        placeholder() {
            if (this.editor.is_chapter) {
                return "章タイトルを入力...";
            }
            return "本文タイトルを入力...";
        },
        plotLength() {
            if (this.editor.plot) {
                return this.editor.plot.length;
            }
            return 0;
        },
    },
    mounted() {
        if (!this.section.section_name && !this.section.plot) {
            this.edit();
        }
    }
}
</script>